import { useMutation, MutationOptions, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { postSimulation } from 'Services';
import { RQ_SINGLE_SIMULATION, RQ_ALL_SIMULATIONS, callAll, RQ_LAST_MINUTE_SIMULATIONS } from 'Utils';

type Props = {
    mutationOptions?: Omit<
        MutationOptions<AxiosResponse<PostSimulationObject> & { id?: string }, any, any, any>,
        'mutationKey'
    >;
    templateRepositoryId: number;
};

function useCreateSimulation({ mutationOptions, templateRepositoryId }: Props) {
    const queryClient = useQueryClient();

    const defaultSuccessHandler = () => {
        queryClient.invalidateQueries([RQ_LAST_MINUTE_SIMULATIONS, templateRepositoryId]);
        queryClient.invalidateQueries([RQ_ALL_SIMULATIONS]);
    };

    return useMutation([RQ_SINGLE_SIMULATION], postSimulation, {
        ...mutationOptions,
        onSuccess: callAll(defaultSuccessHandler, mutationOptions?.onSuccess),
        onError: mutationOptions?.onError
    });
}

export default useCreateSimulation;
